import { Injectable } from '@angular/core';

import { HttpService, NotificationService, TmsWebBaseEditService } from 'tms-lib';
import { ProductTrimmingSpec } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class ProductTrimmingSpecService extends TmsWebBaseEditService<ProductTrimmingSpec, ProductTrimmingSpec> {
  constructor(protected httpService: HttpService, protected notificationService: NotificationService) {
    super('TrimmingSpec', $localize`Trimming Spec`, httpService, notificationService);
  }
}
